import { IEnvironment } from './ienvironment';

export class Environment implements IEnvironment {
	static production: boolean = true;

	private static readonly logLevelSetting: string = '#{ui.logLevel}';
	private static readonly logToConsoleSetting: string = '#{ui.logToConsole}';

	constructor() {
		this.logLevel = parseInt(Environment.logLevelSetting);
		this.logToConsole = Environment.logToConsoleSetting;
	}

	production: boolean = Environment.production;
	logToConsole: string = 'true';
	logLevel: number = 2;

	appInsightsConnectionString: string = '#{ApplicationInsights:ConnectionString}';

	services: { [serviceName: string]: string } = {
		employee: '#{Services:EmployeeApi}/',
	};
	/**
	 * Base domain address to applications
	 */
	baseDomain: { platform: string } = {
		platform: '#{baseUrl.platform}',
	};

}
